import React,{ Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { signOut,getPedido } from '../actions'
import Menu from '../components/user_menu'
import moment from 'moment'

class PedidoDetalle extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false
    	}
    }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    console.log(this.props.match.params.id_pedido)
    this.props.getPedido(this.props.match.params.id_pedido)
  }

  componentDidUpdate(prevProps, prevState){
    console.log(this.props.pedidos);
  }

	render() {  

		if(this.props.pedidos.pedido===null){
			return <div>CARGANDO</div>
		}

    var total=0

    const  listaPedidos = this.props.pedidos.pedidoCont.map((item,i)=>{
      total+=item.precio*item.cantidad
      return (
        <tr key={i}>
          <td><img src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+item.img+".png?alt=media"} width="40" /></td>
          <td>{item.rubro_nombre + " " +item.prod_nombre +" "+item.nombre}</td>
          <td>{item.cantidad}</td>
          <td>${item.precio*item.cantidad}.-</td>
        </tr>
      )
    })

    return <section className="row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3">
          <Menu salirAct={this.props.signOut} />
        </div>
        <div className="col-md-6 mb-3">
          <h1 className="display-4">Detalle</h1>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Imagen</th>
                <th scope="col">Producto</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Monto</th>
              </tr>
            </thead>
            <tbody>{listaPedidos}</tbody>
            <thead>
              <tr>
                <th scope="col">IVA 21%:</th>
                <th scope="col" />
                <th scope="col" />
                <th scope="col">
                  ${((total * 21) / 100).toFixed(2)}
                  .-
                </th>
                <th />
              </tr>
              <tr>
                <th scope="col">{this.props.pedidos.pedido.envio.nombre}</th>
                <th scope="col" />
                <th scope="col" />
                <th scope="col">${this.props.pedidos.pedido.envio.costo}.-
                </th>
              </tr>
              <tr>
                <th scope="col">Total:</th>
                <th scope="col" />
              <th scope="col"></th>
                <th scope="col">
                ${(this.props.pedidos.pedido.envio.costo+(total + (total * 21) / 100)).toFixed(2) }
                  .-
                </th>
                <th />
              </tr>
            </thead>
          </table>
        </div>
      </section>;
  }
}

const mapStateToProps = state => {
	return {
    	usuario: state.usuario,
      pedidos:state.pedidos
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => {
      dispatch(signOut())
    },
    getPedido:(id_pedido) => {
      dispatch(getPedido(id_pedido))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedidoDetalle)




// WEBPACK FOOTER //
// ./src/containers/pedido_detalle.js